import { render } from "./bonusRoundView.vue?vue&type=template&id=2dfde721&scoped=true"
import script from "./bonusRoundView.vue?vue&type=script&lang=js"
export * from "./bonusRoundView.vue?vue&type=script&lang=js"

import "./bonusRoundView.vue?vue&type=style&index=0&id=2dfde721&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfde721"]])

export default __exports__